import { UserInfo } from "../../../accessTokenManager/AccessTokenManager";
import { Action, AnyAction } from "redux";
import { ReduxAction } from "../../../typings";

export const AUTH_STATUS = {
  AUTHORIZED: "AUTHORIZED",
  UNAUTHORIZED: "UNAUTHORIZED",
};

const USER_INFO_PERSISTED = "USER_INFO_PERSISTED";
export const persistUserInfo = (userInfo: UserInfo): ReduxAction<UserInfo> => ({
  type: USER_INFO_PERSISTED,
  payload: userInfo,
});

const USER_INFO_ERASED = "USER_INFO_ERASED";
export const eraseUserInfo = (): Action => ({
  type: USER_INFO_ERASED,
});

export type UserState = {
  status: string;
  name?: string;
  email: string | null;
  // more user fields
};

const defaultState = {
  /*
   * @deprecated
   */
  status: AUTH_STATUS.UNAUTHORIZED,
  email: null,
};

export default function user(
  state: UserState = defaultState,
  action: AnyAction,
): UserState {
  switch (action.type) {
    case USER_INFO_PERSISTED:
      return {
        status: AUTH_STATUS.AUTHORIZED,
        email: action.payload.email,
        name: action.payload.name,
      };
    case USER_INFO_ERASED:
      return defaultState;
    default:
      return state;
  }
}
